import { useEffect } from 'react';
import classnames from 'classnames';
import { ErrorBoundaryProps, withErrorBoundary } from 'react-error-boundary';
import { useAds } from './useAds';
import { AdFormat } from './constants';
import { getAdMinHeight } from './utils';

import './styles.scss';

interface AdsSlotProps {
  id: string;
  path: string;
  className?: string;
  style?: React.CSSProperties;
  format?: string;
  sizeMapping?: googletag.SizeMappingArray;
  targetings?: { key: string; value: string }[];
}

const errorBoundaryProps: ErrorBoundaryProps = {
  fallback: null,
  onError: (error, info) => {
    console.error('Error on loading AdsSlot:', error, info);
  },
};

export const AdsSlot = withErrorBoundary(({ id, path, className, style, format, sizeMapping, targetings }: AdsSlotProps) => {
  if (import.meta.env.VITE_ENV === 'dev') path = '/6355419/Travel/Europe/France/Paris';

  const { createSlot, destroySlot, disableAds } = useAds();

  useEffect(() => {
    if(disableAds) return
    const slot = createSlot(id, path, {
      className,
      format: format as AdFormat,
      sizeMapping,
      targetings,
    });

    return () => {
      if (slot) destroySlot(slot);
    };
  }, [createSlot, destroySlot]);

  if(disableAds) return null

  return (
    <div className={classnames('admanager', className)} style={style}>
      <div
        style={{ minHeight: getAdMinHeight({ format: format as AdFormat, customSizeMapping: sizeMapping }) }}
        className="admanager__content"
        id={id}
      />
    </div>
  );
}, errorBoundaryProps);
